export default __webpack_public_path__ + "static/media/Ladybuggallery.3be8e78a.PNG";